import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PointsHeader({ user, maxPoints, campaign, themeVars = {} }) {
  const accent = themeVars.accent || "#c8f135";
  const card = themeVars.card || "#111111";
  const border = themeVars.border || "#222222";
  const textPrimary = themeVars.textPrimary || "#ffffff";
  const textSecondary = themeVars.textSecondary || "rgba(255,255,255,0.4)";
  const isLight = themeVars.light;
  const progressTrackBg = isLight ? "#e5e7eb" : "#222";

  if (!user) return null;

  const pct = Math.min(100, Math.round(((user.total_points || 0) / (maxPoints || 1)) * 100));
  const [animPct, setAnimPct] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setAnimPct(pct), 120);
    return () => clearTimeout(t);
  }, [pct]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="rounded-2xl p-6 mb-6"
      style={{ background: card, border: `1px solid ${border}` }}
    >
      <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: textSecondary }}>
        {campaign?.title}
      </p>

      <div className="flex items-end justify-between mb-5">
        <div>
          <motion.span
            key={user.total_points}
            initial={{ scale: 1.3 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.4 }}
            className="font-black block"
            style={{ fontSize: "clamp(2.8rem,8vw,4rem)", lineHeight: 1, color: accent }}
          >
            {user.total_points}
          </motion.span>
          <span className="font-black text-xl" style={{ color: `${accent}99` }}>/ {maxPoints}</span>
          <p className="text-sm font-bold mt-1" style={{ color: textSecondary }}>נקודות</p>
        </div>
        <div className="text-left">
          <p className="text-sm font-bold" style={{ color: textSecondary }}>דירוג</p>
          <p className="font-black text-3xl" style={{ color: textPrimary }}>#{user.rank}</p>
          <p className="text-xs" style={{ color: textSecondary }}>מתוך {user.total_participants}</p>
        </div>
      </div>

      <div className="rounded-full h-3 overflow-hidden mb-2" style={{ background: progressTrackBg }}>
        <div
          className="h-full rounded-full"
          style={{
            width: `${animPct}%`,
            background: `linear-gradient(90deg, ${accent}, ${accent}cc)`,
            transition: "width 0.9s cubic-bezier(0.34, 1.56, 0.64, 1)",
          }}
        />
      </div>
      <div className="flex justify-between">
        <span className="text-xs font-bold" style={{ color: textSecondary }}>{pct}% הושלם</span>
        {user.is_maxed_out && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="text-xs font-black"
            style={{ color: accent }}
          >
            🎉 הגעת למקסימום!
          </motion.span>
        )}
      </div>

      <Link
        to="/leaderboard"
        className="mt-4 flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-sm font-bold transition-all"
        style={{ background: `${accent}18`, color: accent, border: `1px solid ${accent}40` }}
      >
        🏆 ראה לידרבורד מלא
      </Link>
    </motion.div>
  );
}